/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AgeGroup {
  Unknown = 'Unknown',
  Age020 = 'Age_0_20',
  Age2130 = 'Age_21_30',
  Age3135 = 'Age_31_35',
  Age3640 = 'Age_36_40',
  Age4145 = 'Age_41_45',
  Age4650 = 'Age_46_50',
  Age5155 = 'Age_51_55',
  Age5660 = 'Age_56_60',
  Age6170 = 'Age_61_70',
  Age7180 = 'Age_71_80',
  Age81Plus = 'Age_81_Plus'
}
